import { Globals } from '../Misc';
import { NeoTypes } from '../AppServices';
import { Utils } from '../Utils';
var ApiClientBase = /** @class */ (function () {
    function ApiClientBase(apiPath, axios) {
        if (axios === void 0) { axios = Globals.appService.get(NeoTypes.Axios); }
        this.apiPath = apiPath;
        this.axios = axios;
        Utils.bindAllMethods(this);
    }
    return ApiClientBase;
}());
export { ApiClientBase };
